import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { CosyLoginComponent } from './cosy-login/cosy-login.component';
import { CosyAsdComponent } from './cosy-asd/cosy-asd.component';
import { CosyServerComponent } from './cosy-server/cosy-server.component';

export const router: Routes = [
  { path: '', redirectTo: '/server', pathMatch: 'full' },
  //{ path: '', redirectTo: '/myapp', pathMatch: 'full' },
  { path: 'server', component: CosyServerComponent },
  { path: 'login', component: CosyLoginComponent },
  { path: 'myapp', component: CosyAsdComponent }
];

export const routes: ModuleWithProviders<RouterModule> = RouterModule.forRoot(router,  {
    scrollPositionRestoration: 'enabled',
    onSameUrlNavigation: 'ignore',
    relativeLinkResolution: 'legacy'
});
